var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73.66l-.252.252a.429.429 0 000 .606l6.375 6.375H.43A.429.429 0 000 8.32v.358c0 .236.192.428.429.428h13.424l-6.375 6.375a.429.429 0 000 .606l.253.253a.429.429 0 00.606 0l7.537-7.538a.429.429 0 000-.606L8.337.659a.428.428 0 00-.606 0z",
    fill: "#fff"
  })));
}

export default SvgArrowRight;